// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MedicalControlPanel-module__headerBox--s5Y67 {
    display: flex;
    gap: 30px;
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    padding: 10px;
    margin-top: 20px;
    text-align: center;
    flex-wrap: wrap;
}

.MedicalControlPanel-module__cardBox--gSN62 {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 180px;
}

.MedicalControlPanel-module__cardBoxInfo--Rm7e0>span {
    color: #0054E6;
    font-size: 35px;
    font-weight: bold;
    margin-right: 10px;
}

.MedicalControlPanel-module__cardBoxInfo--Rm7e0 {
    color: #0054E6;
    margin-bottom: 0;
}

.MedicalControlPanel-module__textDescription--F3pQx {
    display: flex;
    color: #4b5863;
    font-size: 15px;
    font-weight: bold;
}

.MedicalControlPanel-module__titleBarChart--aP87B {
    font-size: 16px;
    font-weight: bold;
    color: #0054E6;
    text-align: center;
}

.MedicalControlPanel-module__barChartBox--A9A8O {
    /* width: 45%;   */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    flex: 1;
    width: 450px;
}

.MedicalControlPanel-module__barChartContainer--H5RFw {
    /* display: flex;
    gap: 15px;
    flex-wrap: wrap;
    margin-top: 10px; */
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    flex-wrap: wrap;
}

.MedicalControlPanel-module__chartsContainer--OWbgp {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    flex-wrap: wrap;
}

.MedicalControlPanel-module__chartWrapper--BGRIM {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
}

.MedicalControlPanel-module__chartPieContainer--qiSrb {
    width: 250px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.MedicalControlPanel-module__chartTitle--wmHnG {
    text-align: center;
    margin-top: 10px;
    font-weight: bold;
    color: #4b5863;
}

.MedicalControlPanel-module__chartsContainer--OWbgp {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    gap: 40px;
}

.MedicalControlPanel-module__chartWrapper--BGRIM {
    display: flex;
    align-items: center;
    width: 450px;
}

.MedicalControlPanel-module__chartPieContainer--qiSrb {
    width: 250px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MedicalControlPanel-module__btnBox--sCKTC {
    display: flex;
    margin-top: 30px;
    justify-content: center;
}
.MedicalControlPanel-module__btnBoxDownload--_j7K_ {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.MedicalControlPanel-module__settingBox--OOyuv {
    display: flex;
    justify-content: end;
    margin-top: 20px;
}

.MedicalControlPanel-module__iconContract--VTSfj>svg {
    color: #6F879C;
}

@media (max-width: 1300px) {
    .MedicalControlPanel-module__headerBox--s5Y67 {
        gap: 20px;
    }
    .MedicalControlPanel-module__cardBox--gSN62 {
    min-width: 130px;
}

.MedicalControlPanel-module__cardBoxInfo--Rm7e0>span {
    font-size: 25px;
}


.MedicalControlPanel-module__textDescription--F3pQx {
    font-size: 10px;
}

}
`, "",{"version":3,"sources":["webpack://./src/features/statistics/ui/MedicalControlPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;IACnD,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,YAAY;AAChB;;AAEA;IACI;;;uBAGmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,SAAS;IACb;IACA;IACA,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;AACnB;;AAEA","sourcesContent":[".headerBox {\r\n    display: flex;\r\n    gap: 30px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    padding: 10px;\r\n    margin-top: 20px;\r\n    text-align: center;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.cardBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    min-width: 180px;\r\n}\r\n\r\n.cardBoxInfo>span {\r\n    color: #0054E6;\r\n    font-size: 35px;\r\n    font-weight: bold;\r\n    margin-right: 10px;\r\n}\r\n\r\n.cardBoxInfo {\r\n    color: #0054E6;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.textDescription {\r\n    display: flex;\r\n    color: #4b5863;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.titleBarChart {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #0054E6;\r\n    text-align: center;\r\n}\r\n\r\n.barChartBox {\r\n    /* width: 45%;   */\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 20px;\r\n    flex: 1;\r\n    width: 450px;\r\n}\r\n\r\n.barChartContainer {\r\n    /* display: flex;\r\n    gap: 15px;\r\n    flex-wrap: wrap;\r\n    margin-top: 10px; */\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 30px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.chartsContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 30px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.chartWrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    flex: 1;\r\n}\r\n\r\n.chartPieContainer {\r\n    width: 250px;\r\n    height: 250px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0 auto;\r\n}\r\n\r\n.chartTitle {\r\n    text-align: center;\r\n    margin-top: 10px;\r\n    font-weight: bold;\r\n    color: #4b5863;\r\n}\r\n\r\n.chartsContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 30px;\r\n    gap: 40px;\r\n}\r\n\r\n.chartWrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 450px;\r\n}\r\n\r\n.chartPieContainer {\r\n    width: 250px;\r\n    height: 250px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    margin-top: 30px;\r\n    justify-content: center;\r\n}\r\n.btnBoxDownload {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.settingBox {\r\n    display: flex;\r\n    justify-content: end;\r\n    margin-top: 20px;\r\n}\r\n\r\n.iconContract>svg {\r\n    color: #6F879C;\r\n}\r\n\r\n@media (max-width: 1300px) {\r\n    .headerBox {\r\n        gap: 20px;\r\n    }\r\n    .cardBox {\r\n    min-width: 130px;\r\n}\r\n\r\n.cardBoxInfo>span {\r\n    font-size: 25px;\r\n}\r\n\r\n\r\n.textDescription {\r\n    font-size: 10px;\r\n}\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerBox": `MedicalControlPanel-module__headerBox--s5Y67`,
	"cardBox": `MedicalControlPanel-module__cardBox--gSN62`,
	"cardBoxInfo": `MedicalControlPanel-module__cardBoxInfo--Rm7e0`,
	"textDescription": `MedicalControlPanel-module__textDescription--F3pQx`,
	"titleBarChart": `MedicalControlPanel-module__titleBarChart--aP87B`,
	"barChartBox": `MedicalControlPanel-module__barChartBox--A9A8O`,
	"barChartContainer": `MedicalControlPanel-module__barChartContainer--H5RFw`,
	"chartsContainer": `MedicalControlPanel-module__chartsContainer--OWbgp`,
	"chartWrapper": `MedicalControlPanel-module__chartWrapper--BGRIM`,
	"chartPieContainer": `MedicalControlPanel-module__chartPieContainer--qiSrb`,
	"chartTitle": `MedicalControlPanel-module__chartTitle--wmHnG`,
	"btnBox": `MedicalControlPanel-module__btnBox--sCKTC`,
	"btnBoxDownload": `MedicalControlPanel-module__btnBoxDownload--_j7K_`,
	"settingBox": `MedicalControlPanel-module__settingBox--OOyuv`,
	"iconContract": `MedicalControlPanel-module__iconContract--VTSfj`
};
export default ___CSS_LOADER_EXPORT___;
